import '@/styles/globals.css'

import { ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import type { AppProps } from 'next/app'
import { AppContextType } from 'next/dist/shared/lib/utils'
import Head from 'next/head'
import React from 'react'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import MwAuthGuard from '@/components/common/MwAuthGuard'
import MwLayout from '@/components/common/MwLayout'
import MwSnackbar from '@/components/common/MwSnackbar'
import ErrorHandler from '@/components/modules/ErrorHandler'
import { theme } from '@/materialTheme'
import queryClientConfig from '@/src/config/reactQueryConfig'
import { isAuthenticated } from '@/src/utils/checkAuth'

const MyApp = ({ Component, pageProps }: AppProps<{ isPage?: string }>) => {
  if (typeof window === 'undefined') React.useLayoutEffect = () => {}
  return (
    <>
      {/* _document.tsxにHeadを置くとwarningが出る */}
      <Head>
        <title>葬祭業務支援システム</title>
        {/* eslint-disable-next-line @next/next/no-css-tags */}
      </Head>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
          <QueryClientProvider client={queryClientConfig}>
            <ReactQueryDevtools initialIsOpen={false} />
            <MwLayout>
              <MwAuthGuard>
                <ErrorHandler isPageName={pageProps?.isPage}>
                  <Component {...pageProps} />
                </ErrorHandler>
              </MwAuthGuard>
            </MwLayout>
            <MwSnackbar />
          </QueryClientProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </>
  )
}

MyApp.getInitialProps = ({ ctx }: AppContextType) => {
  // サーバーサイドでは Cookie の有無のみ確認する。
  // トークンの有効性と画面ごとの権限確認は MwAuthGuard (ブラウザ側) で行う。
  isAuthenticated(ctx)

  return {
    pageProps: {
      isPage: ctx.pathname,
    },
  }
}

export default MyApp
